import { Building2, Contact, Package, Paperclip } from 'lucide-react';

// Single source of truth for the supplier record's tab strip
// (apps/crm/prd/crm-supplier-record.md §2). The route's `validateSearch`
// imports SUPPLIER_RECORD_TAB_IDS from here so the URL contract and the strip
// can never drift.
export const SUPPLIER_RECORD_TABS = [
  { icon: Building2, id: 'info', label: 'Info' },
  { icon: Contact, id: 'contacts', label: 'Contacts' },
  { icon: Paperclip, id: 'attachments', label: 'Attachments' },
  { icon: Package, id: 'linked-products', label: 'Linked Products' },
] as const;

export type SupplierRecordTab = (typeof SUPPLIER_RECORD_TABS)[number]['id'];

export const SUPPLIER_RECORD_TAB_IDS = SUPPLIER_RECORD_TABS.map(
  (tab) => tab.id
) as readonly SupplierRecordTab[];

// Info is the default, and it is written to the URL by OMITTING `?pane=`
// entirely (matching the product-edit convention) so the bare record URL stays
// clean and bookmarkable.
export const SUPPLIER_RECORD_DEFAULT_TAB: SupplierRecordTab = 'info';

export const isSupplierRecordTab = (
  value: unknown
): value is SupplierRecordTab =>
  typeof value === 'string' &&
  (SUPPLIER_RECORD_TAB_IDS as readonly string[]).includes(value);
